<template>
  <div>
    <div style="display:flex; justify-content:space-between; width:100%; height:50px; box-shadow: 0px 5px 10px 0px rgb(0 0 0 / 10%); border-radius:8px; padding:10px; margin-bottom:5px;">
      <div>
        <vs-button color="primary" type="flat" style="font-size: 15px; margin-top:5px; padding:0 5px; text-align:center; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;" @click="showList(examId)"><strong>{{examId.month_week}}</strong></vs-button>
      </div>
      <div v-if="examId.start_date" style="display:flex; margin-top:5px;">
        <p>{{examId.start_date}} ~</p>
        <p>{{examId.end_date}}</p>
      </div>
      <div style="display:flex">
        <vs-button color="success" @click="editExamList(examId)" style="margin-right:3px;" type="border" icon-pack="feather" size="small" icon="icon-edit"></vs-button>
        <vs-button color="#ff0000" @click="deleateExamList(examId)" style="margin-right:3px;" type="border" icon-pack="feather" size="small" icon="icon-x"></vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  EditIcon,
  XIcon
} from 'vue-feather-icons'
export default {
  props:['examId'],
  components: {
    EditIcon,
    XIcon
  },
  data() {
    return {
      examInfo : {}
    }
  },
  watch : {
    data () {
      this.examInfo = this.data
    }
  },
  methods: {
    editExamList(val) {
      this.$emit('open' , {
        info: val,
        state: 1
      })
    },
    deleateExamList(val) {
      this.$emit('remove' , val)
      console.log('123')
    },
    showList(val) {
      this.$emit('getList' , {
        info: val,
        state: 1
      })
      console.log(val)
    }
  },
  created() {
    this.examInfo = this.data
    console.log(this.examId)
  }
}
</script>

<style>
  .edit_btn:hover {
    cursor:pointer
  }
  .delete_btn:hover {
    cursor: pointer
  }
</style>
